module.exports = __webpack_public_path__ + "static/img/zs004.d778631.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs004.jpg
// module id = ylTp
// module chunks = 13